import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import ProfileCard from './componant/ProfileCard';
import Login from './componant/Login';
import Signup from './componant/Signup';
import Video from './componant/Video';
import AssignmentsPage from './componant/AssignmentsPage';
import PdfList from './componant/PdfList';
import PricingCard from './componant/PricingCard';
import AddQuestion from './componant/AddQuestion';
import LessonTable from './componant/LessonTable';
import ListStudent from './componant/ListStudent';
import UserTable from './componant/UserTable';
import UserTable2 from './componant/UserTable2';
import UserTable3 from './componant/UserTable3';
import UserTable4 from './componant/UserTable4';
import CreateCodePage from './componant/CreateCodePage';
import MessagesTable from './componant/MessagesTable';
import Words from './componant/Words';
import Home2 from './componant/FormPage';
import MySubscriptions from './componant/MySubscriptions';

import Home from './NewPlatform/Home';
import StudentPackages from './NewPlatform/StudentPackages';
import Login2 from './NewPlatform/Login2';
import PricingCard2 from './NewPlatform/PricingCard';
import PricingCard22 from './NewPlatform/PricingCard22';
import Main from './components/home/Home';
import Main1 from './components/home/Home2';
import Mains from './components/home/Homes';
import Mains1 from './components/home/Homes2';
import PricingCardIslam from './NewPlatform/PricingCardIslam';

import ProfileCard2 from './NewPlatform/ProfileCard';
import ProfileCardlecIslam from './NewPlatform/ProfileCardlecIslam';

import Video2 from './NewPlatform/Video';
import Signup2 from './NewPlatform/Signup';
import AssignmentsPage2 from './NewPlatform/AssignmentsPage';
import PdfList2 from './NewPlatform/PdfList';
import EducationalVideos from './NewPlatform/EducationalVideos';
import VIDEOislam from './NewPlatform/VIDEOislam';

import Head from "./components/common/header/Head";
import Head2 from "./components/common/header/Head2";
import Head3 from "./components/common/header/Head3";

import Mains2 from './components/home/HomesIslam';
import Mains3 from './components/home/HomesIslam2';

import LoginIslam from './NewPlatform/LoginIslam';
import SignupIslam from './NewPlatform/SignupIslam';

// ----------------------------------------------------
// Component using useLocation (يسمح باستخدام الهيدرات)
// ----------------------------------------------------
function AppContent({ darkMode, toggleDarkMode, isMobile }) {

  const location = useLocation();

  // ROUTES to show <Head />
  const showHeadRoutes = ["/", "/Login", "/Signup", "/PricingCard", "/ProfileCard", "/Teachers", "/Video", "/Codes-Ashraf-admin","/MySubscriptions"];

  // ROUTES to show <Head2 />
  const showHead2Routes = ["/Mr.Monem", "/MakeAccount", "/Signin", "/EducationalVideos", "/Codes-mohamed", "/Card", "/Card2", "/Cardlec", "/VIDEOs"];
  const showHead3Routes = ["/Mr.IslamAbdElazeem", "/SignupIslam", "/LoginIslam", "/CardIslam", "/lecIslam", "/VIDEOislam"];

  const showHead = showHeadRoutes.includes(location.pathname);
  const showHead2 = showHead2Routes.includes(location.pathname);
  const showHead3 = showHead3Routes.includes(location.pathname);

  return (
    <>
      {showHead && <Head darkMode={darkMode} toggleDarkMode={toggleDarkMode} />}
      {showHead2 && <Head2 darkMode={darkMode} toggleDarkMode={toggleDarkMode} />}
      {showHead3 && <Head3 darkMode={darkMode} toggleDarkMode={toggleDarkMode} />}

      <Routes>
        <Route path="/" element={isMobile ? <Main1 darkMode={darkMode}  /> : <Main darkMode={darkMode}  />} />
        <Route path="/Login" element={<Login darkMode={darkMode} />} />
        <Route path="/Signup" element={<Signup darkMode={darkMode} />} />

        <Route path="/Mr.Monem" element={isMobile ? <Mains1 /> : <Mains />} />
        <Route path="/Signin" element={<Login2 />} />
        <Route path="/MakeAccount" element={<Signup2 />} />
        <Route path="/Mr.IslamAbdElazeem" element={isMobile ? <Mains2 /> : <Mains3 />} />
        <Route path="/LoginIslam" element={<LoginIslam />} />
        <Route path="/SignupIslam" element={<SignupIslam />} />
        <Route path="/MySubscriptions" element={<MySubscriptions />} />

        {/* باقي الروتز */}
        <Route path="/ProfileCard" element={<ProfileCard darkMode={darkMode}  />} />
        <Route path="/Video" element={<Video darkMode={darkMode} />} />
        <Route path="/AssignmentsPage" element={<AssignmentsPage />} />
        <Route path="/PdfList" element={<PdfList />} />
        <Route path="/PricingCard" element={<PricingCard darkMode={darkMode} />} />
        <Route path="/AddQuestion" element={<AddQuestion />} />
        <Route path="/LessonTable" element={<LessonTable />} />
        <Route path="/ListStudent" element={<ListStudent />} />
        <Route path="/UserTable" element={<UserTable />} />
        <Route path="/User" element={<UserTable2 />} />
        <Route path="/EducationalVideos" element={<EducationalVideos />} />
        <Route path="/Mr.mohamed Abdelmonem" element={<UserTable3 />} />
        <Route path="/Mr.AshrafAbed" element={<UserTable4 />} />
        <Route path="/lecIslam" element={<ProfileCardlecIslam />} />

        <Route path="/Create" element={<CreateCodePage />} />
        <Route path="/Message" element={<MessagesTable />} />
        <Route path="/Words" element={<Words />} />
        <Route path="/Home2" element={<Home2 />} />
        <Route path="/Teachers" element={<Home darkMode={darkMode}   />} />
        <Route path="/StudentPackages" element={<StudentPackages />} />
        <Route path="/Card" element={<PricingCard2 />} />
        <Route path="/card2" element={<PricingCard22 />} />
        <Route path="/CardIslam" element={<PricingCardIslam />} />

        <Route path="/Cardlec" element={<ProfileCard2 />} />
        <Route path="/VIDEOs" element={<Video2 />} />
        <Route path="/PdfList2" element={<PdfList2 />} />
        <Route path="/AssignmentsPage2" element={<AssignmentsPage2 />} />
        <Route path="/VIDEOislam" element={<VIDEOislam />} />

      </Routes>
    </>
  );
}


// ----------------------------------------------------
// Main App (الذي يحتوي dark mode بدون أي تغيير)
// ----------------------------------------------------
function App() {

  const [isMobile, setIsMobile] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // نفس كود dark mode اللي عندك
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode === "true") setDarkMode(true);
  }, []);

  useEffect(() => {
    if (darkMode) document.body.classList.add("dark-mode");
    else document.body.classList.remove("dark-mode");

    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(prev => !prev);

  // الموبايل
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
  }, []);

  return (
    <Router>
      <AppContent
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        isMobile={isMobile}
      />
    </Router>
  );
}

export default App;
